export const RENDER_EXTRA_INPUT = 'NVVDD'
